function getFromLocalStorage(key: string): string {
  const value: string | null = window.localStorage.getItem(key);
  return value || '';
}

export default getFromLocalStorage;
